// extracted by mini-css-extract-plugin
export default {"layers":"layers___HDQwI","orphaned":"orphaned___bviIP"};